import React from 'react';

const Footer = () =>  {

    const iconPath = process.env.PUBLIC_URL + '/assets/images/';

    return (
        <footer className="footer">
            <div className="footer-logo">
                <img src={`${iconPath}tmdb_logo.svg`} alt="tmdb logo" />
            </div>
            <div className="footer-text">
                <p>&copy; 2020 TMDB All Rights Reserved.</p>
                <p>Vancouver, BC</p>
            </div>
        </footer>
    );
}

export default Footer;